export const colors = [
  'rgba(220, 20, 60, opacity)',
  'rgba(0, 191, 255, opacity)',
  'rgba(80, 200, 120, opacity)',
  'rgba(155, 48, 255, opacity)',
  'rgba(255, 165, 0, opacity)',
  'rgba(255, 105, 180, opacity)',
  'rgba(50, 205, 50, opacity)',
  'rgba(65, 105, 225, opacity)',
  'rgba(255, 215, 0, opacity)',
  'rgba(0, 128, 128, opacity)',
  'rgba(255, 127, 80, opacity)',
  'rgba(25, 25, 112, opacity)',
  'rgba(153, 102, 204, opacity)',
  'rgba(64, 224, 208, opacity)',
  'rgba(128, 128, 0, opacity)',
  'rgba(255, 0, 255, opacity)',
  'rgba(210, 105, 30, opacity)',
  'rgba(112, 128, 144, opacity)',
  'rgba(204, 204, 255, opacity)',
  'rgba(233, 116, 81, opacity)'
];

// listOfColors[lengthOfAllLabels % listOfColors.length]

export const getColor = (
  lengthOfAllLabels: number,
  opacity: string
): string => {
  return colors[lengthOfAllLabels % colors.length].replace('opacity', opacity);
};
